<template>
	<div class="copy-right">
		<!-- header -->
		<!-- <div class="copy-right.block">
			<intellectual-header></intellectual-header>
		</div> -->
		<!-- 导航栏 -->
		<div class="copy-right.block">
			<intellectual-navigation  :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
		</div>
		<div class="+navigation-line"></div>
		<!-- 面包屑 -->
		<div class="copy-right.bread" data-aos="fade-left">
			<Bread :currentPage="{name:'版权商城',path:'/Copyright'}"/>
		</div>
		<div class="copy-right.container">
			<div class="copy-right.item" data-aos="fade-right">
				<img src="../assets/trademarks/trade-head.jpg" alt="">
			</div>
			<div class="copy-right.item +content-box">
				<section>
					<!-- 筛选菜单 -->
					<SelectMenus :allMenus="copyRightAllMenus" data-aos="fade-right" @menusTabs="menusTabs"></SelectMenus>
					<!-- 筛选时间和价格 -->
					<select-tabs :selectTabs="{type:'版权',account:account}" data-aos="fade-right"  @searchEvent="searchEvent"
					@priceSortEvent="priceSortEvent" @timeSortEvent="timeSortEvent" :placeholder="'搜索版权名称'"></select-tabs>
					<!-- 筛选得内容 -->
					<select-lists :lists="copyRightData" :pageParams="pageParams" @updateLists="updateLists"></select-lists>
				</section>
				<section>
					<copy-right-sigin data-aos="fade-left" @showTipsEvent="showTipsEvent"></copy-right-sigin>
					<div class="copy-right.advisory" data-aos="fade-left">
						<button @click="goEvaluation">了解更多</button>
						<button @click="showConsultationEvent">免费咨询</button>
					</div>
				</section>
			</div>
		</div>
		<!-- footer -->
		<common-footer></common-footer>
		<consultation-modal :consultationShow="consultationShow" @closeConsultationEvent="closeConsultationEvent"></consultation-modal>
		<tips-modal :tipsShow="tipsShow" @closeTipsEvent="closeTipsEvent"></tips-modal>
	</div>
</template>

<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import CommonFooter from "../components/common-footer.vue"
	import Bread from '../components/bread.vue'
	import SelectMenus from '../components/select-menus.vue'
	import SelectTabs from "../components/select-tabs.vue"
	import SelectLists from '../components/select-lists.vue'
	import CopyRightSigin from '../components/copy-right-sigin.vue'
	import ConsultationModal from '../components/consultation-modal.vue'
	import TipsModal from '../components/tips-modal.vue'
	
	export default{
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			CommonFooter,
			Bread,
			SelectMenus,
			SelectTabs,
			SelectLists,
			CopyRightSigin,
			ConsultationModal,
			TipsModal
		
		},
		data(){
			return{
				searchVal:'',
				account:0,
				priceSort:'',
				timeSort:'',
				pageParams:{
					totalMCount: 0,
					pageMNo: 1,
				},
				isTrademark:false,
				consultationShow:false,
				tipsShow:false,
				copyRightAllMenus: [{
						type: '版权类型',
						lists: [{
							name: '软件著作权'
						}, {
							name: '美术作品'
						}, {
							name: '文字作品'
						},{
							name: '音乐作品'
						},{
							name: '摄影作品'
						},{
							name: '模型作品'
						},{
							name: '录像作品'
						},{
							name: '其他作品'
						}],
						isShowBtn: true,
				}],
				copyRightLists:[
					{title:'SEBE 拾贝',desc:'让创新保护，不再困难',icon:require('../assets/trademarks/list-test.png'),id:0},
				],
				type:''
			}
		},
		computed:{
			copyRightData(){
				 return this.copyRightLists.map(({ name, image, introduction, id}) => {
							return {
								title: name,
								icon: this.imgUrl + image,
								desc: introduction,
								id: id ,
							}
						})
			}
		},
		methods:{
			goEvaluation(){
				this.$router.push('/Evaluation')
			},
			closeConsultationEvent(val){
				this.consultationShow = val
			},
			showConsultationEvent(val){
				this.consultationShow = val
			},
			showTipsEvent(val){
				//console.log(123)
				this.tipsShow = val
			},
			closeTipsEvent(val){
				this.tipsShow = val
			},
			toggleTrademarks(val){
					this.isTrademark = val
			},
			updateLists(val){
				this.initCopyRightLists(val)
			},
			initCopyRightLists(page){
				page = page ? page : 1;
				this.http.get(`IPR_Copyright?page=${page}&name=${this.$route.query.name ? this.$route.query.name : this.searchVal}&price=${this.priceSort}&check_time=${this.timeSort}`).then(res => {
					this.copyRightLists = res.data.data
					this.pageParams.totalMCount = res.data.total
					this.account = res.data.total
				})
			},
			searchData(){
				this.http.get(`IPR_Copyright?name=${this.searchVal}&type=${this.type}&price=${this.priceSort}&check_time=${this.timeSort}`).then(res => {
					this.copyRightLists = res.data.data
					this.pageParams.totalMCount = res.data.total
					this.account = res.data.total
					
				})
			},
			searchEvent(keyValue){
				this.searchVal = keyValue
				this.searchData()
				
			},
			menusTabs(tabs){
				let typeId = [];
				tabs.map((item,index) => {
				   typeId.push(parseInt(item.type.slice(7)) + 1)
				})
				this.type = typeId.join(',')
				this.searchData()
			},
			priceSortEvent(type){
				this.priceSort = type.priceType
				this.timeSort= type.timeType
				this.searchData()
			},
			timeSortEvent(type){
				this.priceSort = type.priceType
				this.timeSort= type.timeType
				this.searchData()
			}
			
		},
		mounted(){
			this.initCopyRightLists()
		}
	}
</script>

<style lang="scss">
	@include component(copy-right){
		@include part(block) {
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			width: 100%;
			background: #fff;
		}
		@include part(bread){
			width: 100%;
			min-width: $minWidth;
			height: 51px;
			background: #fff;
		}
		@include part(container){
			width: 100%;
			background: #F7F7F7;
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			
		}
		@include part(item){
			width: 1200px;
			margin: 0 auto;
			padding-top: 18px;
			padding-bottom: 18px;
		}
		@include part(advisory){
			width:100%;
			height:210px;
			margin-top: 10px;
			background: url(../assets/banquan-bg.jpg);
			display: flex;
			align-items: flex-end;
			justify-content: center;
			padding-bottom:18px;
			button{
				width:90px;
				height:40px;
				box-shadow:0px 2px 5px 0px rgba(0, 0, 0, 0.2);
				border-radius:5px;
				border: none;
				outline: none;
				font-size: 16px;
				font-weight:bold;
				cursor:pointer;
				&:nth-child(1){
					background:linear-gradient(90deg,rgba(213,218,252,1) 0%,rgba(255,255,255,1) 100%);
					color: #960EFD;
					margin-right: 10px;
				}
				&:nth-child(2){
					background:linear-gradient(90deg,rgba(255,155,0,1) 0%,rgba(254,191,0,1) 100%);
					color: #FFFFFF;
				}
			}
			
		}
		@include tweak(content-box){
			display: flex;
			justify-content: space-between;
			section{
				
				&:nth-child(1){
					width:940px;
	
				}
				&:nth-child(2){
					width:240px;
				}
			}
		}
	}
</style>
